// extracted by mini-css-extract-plugin
module.exports = {"apply":"apply-and-reminder_apply__Y4Gdw","apply-btn":"apply-and-reminder_apply-btn__7dsaU","reminder":"apply-and-reminder_reminder__rRLhu"};